module.exports = __webpack_public_path__ + "static/media/cardOrdersEasilyIcon.faf13aad.svg";